module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "promotion_personal_contact.97c4dc27.png";